// Wrapped so nothing here becomes a global lexical binding: these load as
// classic `defer` scripts, and a top-level `const`/`class` name colliding with
// another theme script is a parse-time SyntaxError that kills the whole file.
(() => {
  // `style.setProperty` is used only to write the `--hira-size-guide-ratio` custom
  // property. A continuous 0-1 track position cannot be expressed as a class, and a
  // custom property is the sanctioned channel for a dynamic value. No CSS
  // declaration is ever set from here.

  class HiraSizeGuideSection extends HTMLElement {
    constructor() {
      super();
      this._onRangeInput = this._onRangeInput.bind(this);
    }

    connectedCallback() {
      this._range = this.querySelector('[data-size-guide-range]');
      this._valueOut = this.querySelector('[data-size-guide-value]');
      this._daysOut = this.querySelector('[data-size-guide-days]');
      this._sprays = Number(this.dataset.sizeGuideSprays) || 0;

      if (!this._range) return;

      this._floor = Number(this._range.dataset.sizeGuideFloor) || Number(this._range.min);

      this._range.addEventListener('input', this._onRangeInput);

      // Firefox and bfcache restores can hand back a previously selected value, so
      // one sync pass keeps the readout, the days cell and the fill consistent with
      // whatever the input actually holds.
      this._onRangeInput();
    }

    disconnectedCallback() {
      this._range?.removeEventListener('input', this._onRangeInput);
    }

    _onRangeInput() {
      const min = Number(this._range.min);
      const max = Number(this._range.max);
      let value = Number(this._range.value);

      // The input's own `min` is the start of the visible track (0) so the scale
      // reads as a true 0-8 range. `floor` is the lowest value a merchant allows,
      // so anything below it is snapped back — that is what keeps 0 unselectable
      // by drag and by arrow key while still being drawn on the track.
      if (value < this._floor) {
        value = this._floor;
        this._range.value = value;
      }

      if (this._valueOut) this._valueOut.textContent = value;
      if (this._daysOut && value > 0 && this._sprays > 0) {
        this._daysOut.textContent = Math.floor(this._sprays / value);
      }

      const ratio = max > min ? (value - min) / (max - min) : 0;
      this._range.style.setProperty('--hira-size-guide-ratio', ratio.toFixed(4));
    }
  }

  if (!customElements.get('hira-size-guide-section')) {
    customElements.define('hira-size-guide-section', HiraSizeGuideSection);
  }
})();
